import React from 'react';
import {injectIntl} from 'react-intl';
import axios from 'axios';
import classNames from 'classnames';
import config from '../../../../config';
import FullscreenChart from './FullscreenChart';

const SUBDIVISION_ADM1 = 'adm1';
const SUBDIVISION_ADM2 = 'adm2';

const buildOptions = (config, data, hints, intl, mapData, subdivision) => {
    const seriesData = Object.entries(data.series[0].values[subdivision]).map(([key, value]) => [key.toLowerCase(), value]);
    return {
        title: {
            text: config.title, // title.text will be truncated by FullscreenChart component
        },
        legend: {
            enabled: false,
        },
        series: [{
            name: config.title,
            data: seriesData,
            mapData,
        }],
    };
};

const GeoWidget = ({intl, data, params, hints}) => {
    const [mapData, setMapData] = React.useState();
    const [subdivision, setSubdivision] = React.useState(SUBDIVISION_ADM1);
    const options = React.useMemo(() => buildOptions(params, data, hints, intl, mapData, subdivision), [params, data, hints, intl, mapData, subdivision]);
    React.useEffect(() => {
        const cancelTokenSource = axios.CancelToken.source();
        axios.get(`${config.publicPath}static/geojson/it-${subdivision}.geo.json`, {cancelToken: cancelTokenSource.token})
            .then((response) => {
                setMapData(response.data);
            });
        return () => {
            cancelTokenSource.cancel();
        };
    }, [subdivision]);
    const setAdm1 = React.useCallback(() => {
        if (subdivision != SUBDIVISION_ADM1) {
            setMapData(null);
            setSubdivision(SUBDIVISION_ADM1);
        }
    }, [subdivision]);
    const setAdm2 = React.useCallback(() => {
        if (subdivision != SUBDIVISION_ADM2) {
            setMapData(null);
            setSubdivision(SUBDIVISION_ADM2);
        }
    }, [subdivision]);
    if (!mapData) {
        return null;
    }
    return (
        <FullscreenChart hints={hints} options={options} customLabel={`n=${data.count}`}
            constructorType="mapChart" map>
            <div className="btn-toolbar btn-group geo-widget__map-toolbar">
                <button className={classNames('btn btn-sm btn-outline-dark', {active: subdivision === SUBDIVISION_ADM1})}
                    onClick={setAdm1}>regioni</button>
                <button className={classNames('btn btn-sm btn-outline-dark', {active: subdivision === SUBDIVISION_ADM2})}
                    onClick={setAdm2}>province</button>
            </div>
        </FullscreenChart>
    );
};

export default injectIntl(GeoWidget);
